import React, { Component } from 'react';
import DatePicker from 'react-datepicker';

export default class OnHoldReminderModal extends Component {
    constructor(props) {
        super(props);

        this.state = {
            date: null,
        };
    }

    handleDateChange = (date) => {
        this.setState({
            date: date,
        });
    };

    stopPropagation = (e) => {
        e.stopPropagation();
    };

    saveReminderDate = (e) => {
        e.stopPropagation();

        let formData = new FormData();
        formData.append('date', moment(this.state.date).format('YYYY/MM/DD'));

        axios
            .post(`/jobs/${this.props.job.id}/on-hold-reminder`, formData)
            .then((res) => {
                toastr.success('Reminder saved successfully');
                window.location.reload();
            })
            .catch((err) => {
                toastr.error('There was a problem, please try again');
            });
    };

    render() {
        return (
            <div
                className="admin-notes-modal"
                onClick={(e) => {
                    e.stopPropagation();
                }}
            >
                <div className="admin-notes-modal-body">
                    <div className="admin-modal-content">
                        <h4>Set Reminder</h4>
                        <hr />
                        <div className="form-group">
                            <label htmlFor="date">Date</label>
                            <DatePicker
                                selected={this.state.date}
                                onChange={(date) => this.handleDateChange(date)}
                                onClick={(e) => this.stopPropagation(e)}
                                minDate={new Date(new Date().setDate(new Date().getDate() + 1))}
                                dateFormat="dd/MM/yyyy"
                                className="form-control"
                                placeholderText="Set reminder"
                            />
                        </div>
                        <div className="form-group">
                            <button
                                className="btn btn-cw-primary ml-2"
                                onClick={(e) => this.saveReminderDate(e)}
                                disabled={this.state.date === null}
                            >
                                Save
                            </button>
                        </div>
                    </div>
                    <hr />
                    <div className="admin-notes-modal-footer">
                        <button className="btn btn-cw-primary" onClick={(e) => this.props.onHide(e, false)}>
                            Close
                        </button>
                    </div>
                </div>
            </div>
        );
    }
}
